/**
 * Localhost Machine estate seed — preview paint only.
 * Soft≠Live: never used outside isLocalHost(); honesty = soft_preview.
 */
import { softCapsPut, softCapsGet } from "./machine-caps-soft-store.js";

const KEY = "croc-soft-machine-estate-v1";

const SEED = [
  {
    id: "CROC-LOCAL-GATE-01",
    label: "Gate Node A",
    online: true,
    group: "North perimeter",
    zone: "Gate-1",
    site: "HQ",
    kind: "ESP32-S3 · sentinel",
    fw: "1.8.4",
    net: "Wi-Fi",
    hbAgeS: 12,
    claimed: ["snapshot", "siren", "mesh"],
    detail: {
      display_label: "Gate Node A",
      notification_group: "North perimeter",
      ip: "192.168.14.21",
      lan_ip: "192.168.14.21",
      wifi_ip: "192.168.14.121",
      lan_up: true,
      gateway: "192.168.14.1",
      subnet: "255.255.255.0",
      mac_display: "A4:CF:12:90:3B:01",
      link: "wifi",
      site: "HQ",
      zone: "Gate-1",
      map_lat: 3.14825,
      map_lng: 101.69540,
      location_source: "GNSS",
      location_ts: Math.floor(Date.now() / 1000) - 40,
      location_conf_q: 180,
      storage_card: {
        present: true, mounted: true, fs: "FAT32",
        capacity_mb: 16384, free_mb: 9216, health: "ok",
      },
      board_profile: "ESP32-S3 · sentinel",
      fw: "1.8.4",
      fw_latest: "1.9.0",
      upgrade_available: true,
      firmware_hint: {
        update_available: true,
        to_version: "1.9.0",
        release_notes: "Perimeter mesh + siren timing · local peek only.",
      },
      ssid: "Sentinel-Gate",
      udock_state: "active",
      mesh_state: "connected",
      edge_ai_enabled: true,
      honesty: "soft_preview",
    },
    pins: [
      { role: "siren", state: "claimed" },
      { role: "panic", state: "claimed" },
      { role: "", state: "free" },
      { role: "", state: "free" },
    ],
  },
  {
    id: "CROC-LOCAL-YARD-02",
    label: "Yard Cam Hub",
    online: true,
    group: "Yard west",
    zone: "Yard-W",
    site: "HQ",
    kind: "Edge AI node",
    fw: "2.1.0",
    net: "LAN",
    hbAgeS: 4,
    claimed: ["snapshot", "edge_ai", "gpio"],
    detail: {
      display_label: "Yard Cam Hub",
      notification_group: "Yard west",
      ip: "10.20.8.44",
      gateway: "10.20.8.1",
      subnet: "255.255.255.0",
      mac_display: "B8:27:EB:11:C2:90",
      link: "ethernet",
      site: "HQ",
      zone: "Yard-W",
      map_lat: 3.15110,
      map_lng: 101.68990,
      location_source: "INSTALL_SEAL",
      location_ts: Math.floor(Date.now() / 1000) - 120,
      location_conf_q: 200,
      storage_card: {
        present: true, mounted: false, fs: "exFAT",
        capacity_mb: 32768, free_mb: 28000, health: "ok",
      },
      board_profile: "Edge AI node",
      fw: "2.1.0",
      fw_latest: "2.1.0",
      upgrade_available: false,
      udock_state: "off",
      mesh_state: "active",
      edge_ai_enabled: true,
      honesty: "soft_preview",
    },
    pins: [
      { role: "relay_a", state: "claimed" },
      { role: "relay_b", state: "claimed" },
      { role: "tamper", state: "claimed" },
      { role: "", state: "free" },
      { role: "", state: "free" },
      { role: "", state: "free" },
    ],
  },
  {
    id: "CROC-LOCAL-QUIET-03",
    label: "Quiet Store Room",
    online: false,
    group: "Indoor",
    zone: "Store-B",
    site: "Depot",
    kind: "ESP32 · lite",
    fw: "1.6.2",
    net: "Wi-Fi",
    hbAgeS: 86000,
    claimed: ["snapshot"],
    detail: {
      display_label: "Quiet Store Room",
      notification_group: "Indoor",
      ip: "192.168.14.88",
      gateway: "192.168.14.1",
      subnet: "255.255.255.0",
      mac_display: "24:0A:C4:55:01:DE",
      link: "wifi",
      site: "Depot",
      zone: "Store-B",
      map_lat: 3.14010,
      map_lng: 101.70120,
      location_source: "MANUAL",
      location_ts: Math.floor(Date.now() / 1000) - 3600,
      location_conf_q: 120,
      storage_card: {
        present: false, mounted: false, fs: "",
        capacity_mb: null, free_mb: null, health: "empty",
      },
      board_profile: "ESP32 · lite",
      fw: "1.6.2",
      fw_latest: "1.8.4",
      upgrade_available: true,
      firmware_hint: {
        update_available: true,
        to_version: "1.8.4",
        release_notes: "Lite board · GPIO debounce · local peek.",
      },
      ssid: "",
      udock_state: false,
      mesh_state: "disconnected",
      edge_ai_enabled: false,
      honesty: "soft_preview",
    },
    pins: [{ role: "", state: "free" }, { role: "", state: "free" }],
  },
];

export const SOFT_BOARD_OPTIONS = [
  "ESP32-S3 · sentinel",
  "ESP32 · lite",
  "Edge AI node",
  "PoE camera bridge",
];

export const SOFT_SITE_OPTIONS = ["HQ", "Depot", "Yard campus", "Remote post"];

function readFlag() {
  try {
    return sessionStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

function writeFlag() {
  try {
    sessionStorage.setItem(KEY, "1");
  } catch {
    /* ignore */
  }
}

/** Seed preview caps once per localhost session. */
export function ensureSoftEstate() {
  if (readFlag()) return softEstateHubRows();
  for (const row of SEED) {
    if (!softCapsGet(row.id)) {
      softCapsPut(row.id, {
        claimed: row.claimed.slice(),
        verified: row.online ? row.claimed.slice(0, 1) : [],
        deviceType: "edge_ai_node",
      });
    }
  }
  writeFlag();
  return softEstateHubRows();
}

export function softEstateHubRows() {
  return SEED.map((row) => ({
    id: row.id,
    label: row.label,
    online: !!row.online,
    zone: row.zone,
    group: row.group,
    /* Preview label only — not Live device.site_id (SoR gap). */
    site: row.site,
    kind: row.kind,
    fw: row.fw,
    hbAgeS: row.hbAgeS,
    net: row.net,
    raw: {
      honesty: "soft_preview",
      soft_estate: true,
      soft_site_label: row.site,
      ...row.detail,
      /* Strip Soft theatre `site` so Live readers do not treat it as site_id. */
      site: undefined,
      site_id: undefined,
    },
  }));
}

export function softEstateDetailOf(deviceId) {
  const did = String(deviceId || "").trim();
  const row = SEED.find((r) => r.id === did);
  if (!row) return null;
  return {
    ...row.detail,
    honesty: "soft_preview",
    soft_site_label: row.site,
    /* Soft≠Live: no Live site_id on device_state yet — preview label only. */
    site_id: undefined,
    site: row.site,
  };
}

/** Localhost zone rings around seeded pins — preview geometry only. */
export function softEstateZonesOf(siteId = "") {
  const site = String(siteId || "").trim();
  const rows = SEED.filter((r) => !site || r.site === site || site === "default");
  return rows.map((r) => {
    const lat = Number(r.detail && r.detail.map_lat);
    const lng = Number(r.detail && r.detail.map_lng);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    const d = 0.004;
    return {
      zone_id: r.zone,
      id: r.zone,
      label: r.zone,
      /* Soft ring key — not Live device.site_id SoR. */
      soft_site_label: r.site,
      honesty: "soft_preview",
      ring: [
        [lng - d, lat - d],
        [lng + d, lat - d],
        [lng + d, lat + d],
        [lng - d, lat + d],
        [lng - d, lat - d],
      ],
    };
  }).filter(Boolean);
}

export function softEstatePinsOf(deviceId) {
  const did = String(deviceId || "").trim();
  const row = SEED.find((r) => r.id === did);
  return row && Array.isArray(row.pins) ? row.pins.slice() : [];
}

export function softEstateIds() {
  return SEED.map((r) => r.id);
}
